import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, BaseRouteReuseStrategy } from '@angular/router';

/**
 * Angular reuses a component when only its route params change, so a detail view
 * keeps every field the new record does not overwrite. Routes with
 * `data: { recreateOnParamChange: true }` get a fresh component per param set instead.
 */
@Injectable()
export class RecreateOnParamChangeStrategy extends BaseRouteReuseStrategy {
  override shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    if (future.routeConfig === curr.routeConfig && future.data?.['recreateOnParamChange']) {
      return JSON.stringify(future.params) === JSON.stringify(curr.params);
    }
    return super.shouldReuseRoute(future, curr);
  }
}
